<template>
  <div class="reimbursement-search">
    <div class="top-container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="100px"
      >
        <div class="row">
          <el-form-item label="单据类型：" prop="billType">
            <SelectDepartmentTree
              :departmentList="reimbursementTypeList"
              :departmentId="reimbursementTypeId"
              @selectTreeNodeList="selectReimbursementTypeTreeNodeList"
            >
            </SelectDepartmentTree>
          </el-form-item>
          <el-form-item label="单据号：" prop="billCode">
            <el-input class="gray white w240" placeholder="请输入" v-model="ruleForm.billCode" clearable></el-input>
          </el-form-item>
          <el-form-item label="经办人：" prop="agent">
            <el-input class="gray white w200" placeholder="请输入" v-model="ruleForm.agent" clearable></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="部门：" >
            <SelectDepartmentTree
              :departmentList="departmentList"
              :departmentId="departmentId"
              @selectTreeNodeList="selectTreeNodeList"
            >
            </SelectDepartmentTree>
          </el-form-item>
          <el-form-item label="发起时间：" prop="date">
            <el-date-picker
              class="w240 gray white"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              v-model="ruleForm.date"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <el-select
              v-model="ruleForm.status"
              placeholder="请选择"
              class="w200"
            >
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="开支内容：" prop="content">
            <el-input class="gray white w200" placeholder="请输入" v-model="ruleForm.content" clearable></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
            <el-button class="btn-blue" type="primary" @click="search">搜索</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="container">
      <div class="table">
        <el-table
          :data="tableData"
        >
          <el-table-column prop="billCode" label="单据号" width="180">
            <template slot-scope="scope">
              <div class="table-billCode" @click="lookDetails(scope.row)">
                {{ scope.row.billCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :width="item.width"
            show-overflow-tooltip
          />
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <div class="table-status">
                <span class="spot" :class="scope.row.status == 3? 'red':scope.row.status == 2?'blue':scope.row.status == 5?'spot-gray':'green'"></span>
                <span>{{ scope.row.statusVal }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="finishTime" label="审批完成时间" width="150"></el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import { formatTimeToDate, mapChild, mapId2, mapId3, handleAmount } from "@/common/js/utils.js"
import { statusMixins } from '@/common/mixins/status/status.js'
import BillSearch from "@/models/bill-search.js";
import SelectDepartmentTree from "@/components/select-department-tree";
import Staff from "@/models/staff.js";
import BillAdmin from "@/models/bill-admin.js";
export default {
  mixins: [statusMixins],
  components: {
    PaginationTpl,
    SelectDepartmentTree
  },

  data() {
    return {
      ruleForm: {
        billType: '',
        billCode: '',
        agent: '',
        date: '',
        status: '',
        content: ''
      },
      reimbursementTypeId: 0,
      reimbursementTypeList: [],
      departmentId: 0,
      departmentList: [],
      statusList: [
        {id:1, name: '审批中'},
        {id:2, name: '已同意'},
        {id:3, name: '已驳回'},
        {id:4, name: '待审批'},
        {id:5, name: '已作废'},
      ],
      tableData: [],
      tableTitleList: [
        { prop: "billType", lable: "单据类型", width: "" },
        { prop: "agent", lable: "经办人", width: "" },
        { prop: "balance", lable: "金额", width: "" },
        { prop: "department", lable: "部门", width: "" },
        { prop: "createTime", lable: "发起时间", width: "150" },
      ],
      totalNum: 0,
      currentPage: 1,
      timerId: null
    }
  },
  beforeCreate() {
    this.timerId = setTimeout(() => {
      this.$bus.emit('isShowTopMenu', true)
    })
  },

  created() {
    config()
    this.initDepartment()
    this.initReimbursementList()
    this.initReimbursementTypeList()
  },

  beforeDestroy () {
    clearTimeout(this.timerId)
  },

  methods: {
    initReimbursementList() {
      let data = {}
      data.reimbursementFormId = this.ruleForm.billType
      data.code = this.ruleForm.billCode
      data.username = this.ruleForm.agent
      data.deptId = this.departmentId == 0? '':this.departmentId
      data.startDate = this.ruleForm.date ? this.ruleForm.date[0] : ''
      data.endDate = this.ruleForm.date ? this.ruleForm.date[1] : ''
      data.status = this.ruleForm.status
      data.content = this.ruleForm.content
      data.currentPage = this.currentPage
      BillSearch.getReimbursementList(data).then(res => {
        if (res.success) {
          let arr = []
          this.totalNum = res.result.totalNum
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.billCode = i.code
            obj.type = i.type
            obj.billType = i.reimbursementFormName
            obj.agent = i.username
            obj.balance = handleAmount(i.amount,2)
            obj.department = i.deptName
            obj.createTime = formatTimeToDate(i.createTime)
            obj.status = i.status
            obj.statusVal = this.BILL_SEARCH_REIMBURSEMENT_STATUS[i.status]
            obj.finishTime = i.finishTime == 0 ? '': formatTimeToDate(i.finishTime)
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initDepartment() {
      let searchDepartment = ''
      let id = ''
      let keyword = 'reimburse'
      Staff.getChangeDepartmentList(id, searchDepartment, keyword).then(res => {
        if (res.success) {
          let arr = mapChild(res.result);
          this.departmentList = mapId2(arr, this.departmentId)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
  
    /* 获取报销单单据类型数据 */
    initReimbursementTypeList() {
      let queryStr = ''
      BillAdmin.getReimbursementTypeList(queryStr).then(res => {
        if (res.success) {
          let arr = this.mapChild(res.result);
          this.reimbursementTypeList = mapId3(arr, this.reimbursementTypeId)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    mapChild(child) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        obj.id = value.id;
        obj.departmentName = value.name;
        obj.level = value.level;
        obj.reimbursementTypeId = value.reimbursementTypeId ? value.reimbursementTypeId : ''
        if (value.reimburseFormList && value.reimburseFormList.length > 0) {
          obj.subList = this.mapChild(value.reimburseFormList);
          obj.disabled = true
        } else {
          obj.subList = [];
          obj.disabled = false
        }
        arr.push(obj);
      });
      return arr;
    },

    selectReimbursementTypeTreeNodeList(v) {
      this.reimbursementTypeId = v.id
      this.ruleForm.billType = v.id
    },

    selectTreeNodeList(v) {
      this.departmentId = v.id
    },
    
    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initReimbursementList();
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initReimbursementList();
    },

    /* 重置 */
    resetForm(formName) {
      this.departmentId = 0
      this.reimbursementTypeId = 0
      this.$nextTick(() => {
        this.$bus.emit('getFepartmentId', 0)
      })
      this.$refs[formName].resetFields();
    },

    lookDetails(row) {
      this.$router.push({
        path: '/fire/reimbursementModuleIndex/billSearchIndex/reimbursementDetails',
        query: {
          id: row.id,
          type: row.type,
          billCode: row.billCode
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.reimbursement-search {
  .table-billCode {
    cursor: pointer;
  }
}
</style>
